/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { adminContentControllerCreate } from '../fn/content/admin-content-controller-create';
import { AdminContentControllerCreate$Params } from '../fn/content/admin-content-controller-create';
import { adminContentControllerDelete } from '../fn/content/admin-content-controller-delete';
import { AdminContentControllerDelete$Params } from '../fn/content/admin-content-controller-delete';
import { adminContentControllerFindById } from '../fn/content/admin-content-controller-find-by-id';
import { AdminContentControllerFindById$Params } from '../fn/content/admin-content-controller-find-by-id';
import { adminContentControllerSearch } from '../fn/content/admin-content-controller-search';
import { AdminContentControllerSearch$Params } from '../fn/content/admin-content-controller-search';
import { adminContentControllerToggleExpose } from '../fn/content/admin-content-controller-toggle-expose';
import { AdminContentControllerToggleExpose$Params } from '../fn/content/admin-content-controller-toggle-expose';
import { adminContentControllerTogglePin } from '../fn/content/admin-content-controller-toggle-pin';
import { AdminContentControllerTogglePin$Params } from '../fn/content/admin-content-controller-toggle-pin';
import { adminContentControllerUpdate } from '../fn/content/admin-content-controller-update';
import { AdminContentControllerUpdate$Params } from '../fn/content/admin-content-controller-update';
import { ContentDto } from '../models/content-dto';
import { ContentSearchResponseDto } from '../models/content-search-response-dto';
import { userContentControllerFindById } from '../fn/content/user-content-controller-find-by-id';
import { UserContentControllerFindById$Params } from '../fn/content/user-content-controller-find-by-id';
import { userContentControllerSearch } from '../fn/content/user-content-controller-search';
import { UserContentControllerSearch$Params } from '../fn/content/user-content-controller-search';

@Injectable({ providedIn: 'root' })
export class ContentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `adminContentControllerSearch()` */
  static readonly AdminContentControllerSearchPath = '/api/content/admin/search';

  /**
   * 콘텐츠 검색.
   *
   * 콘텐츠를 검색합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminContentControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminContentControllerSearch$Response(params: AdminContentControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentSearchResponseDto>> {
    return adminContentControllerSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 검색.
   *
   * 콘텐츠를 검색합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminContentControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminContentControllerSearch(params: AdminContentControllerSearch$Params, context?: HttpContext): Observable<ContentSearchResponseDto> {
    return this.adminContentControllerSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContentSearchResponseDto>): ContentSearchResponseDto => r.body)
    );
  }

  /** Path part for operation `adminContentControllerFindById()` */
  static readonly AdminContentControllerFindByIdPath = '/api/content/admin/{id}';

  /**
   * 콘텐츠 조회.
   *
   * 콘텐츠를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminContentControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminContentControllerFindById$Response(params: AdminContentControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentDto>> {
    return adminContentControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 조회.
   *
   * 콘텐츠를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminContentControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminContentControllerFindById(params: AdminContentControllerFindById$Params, context?: HttpContext): Observable<ContentDto> {
    return this.adminContentControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContentDto>): ContentDto => r.body)
    );
  }

  /** Path part for operation `adminContentControllerDelete()` */
  static readonly AdminContentControllerDeletePath = '/api/content/admin/{id}';

  /**
   * 콘텐츠 삭제.
   *
   * 콘텐츠를 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminContentControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminContentControllerDelete$Response(params: AdminContentControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return adminContentControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 삭제.
   *
   * 콘텐츠를 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminContentControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminContentControllerDelete(params: AdminContentControllerDelete$Params, context?: HttpContext): Observable<void> {
    return this.adminContentControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `adminContentControllerUpdate()` */
  static readonly AdminContentControllerUpdatePath = '/api/content/admin/{id}';

  /**
   * 콘텐츠 수정.
   *
   * 콘텐츠를 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminContentControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminContentControllerUpdate$Response(params: AdminContentControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentDto>> {
    return adminContentControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 수정.
   *
   * 콘텐츠를 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminContentControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminContentControllerUpdate(params: AdminContentControllerUpdate$Params, context?: HttpContext): Observable<ContentDto> {
    return this.adminContentControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContentDto>): ContentDto => r.body)
    );
  }

  /** Path part for operation `adminContentControllerCreate()` */
  static readonly AdminContentControllerCreatePath = '/api/content/admin';

  /**
   * 콘텐츠 등록.
   *
   * 콘텐츠를 등록합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminContentControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminContentControllerCreate$Response(params: AdminContentControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentDto>> {
    return adminContentControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 등록.
   *
   * 콘텐츠를 등록합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminContentControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminContentControllerCreate(params: AdminContentControllerCreate$Params, context?: HttpContext): Observable<ContentDto> {
    return this.adminContentControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContentDto>): ContentDto => r.body)
    );
  }

  /** Path part for operation `adminContentControllerToggleExpose()` */
  static readonly AdminContentControllerToggleExposePath = '/api/content/admin/{id}/expose';

  /**
   * 콘텐츠 상태 변경.
   *
   * 콘텐츠의 상태를 변경합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminContentControllerToggleExpose()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminContentControllerToggleExpose$Response(params: AdminContentControllerToggleExpose$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentDto>> {
    return adminContentControllerToggleExpose(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 상태 변경.
   *
   * 콘텐츠의 상태를 변경합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminContentControllerToggleExpose$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminContentControllerToggleExpose(params: AdminContentControllerToggleExpose$Params, context?: HttpContext): Observable<ContentDto> {
    return this.adminContentControllerToggleExpose$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContentDto>): ContentDto => r.body)
    );
  }

  /** Path part for operation `adminContentControllerTogglePin()` */
  static readonly AdminContentControllerTogglePinPath = '/api/content/admin/{id}/pin';

  /**
   * 콘텐츠 고정.
   *
   * 콘텐츠를 고정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminContentControllerTogglePin()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminContentControllerTogglePin$Response(params: AdminContentControllerTogglePin$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentDto>> {
    return adminContentControllerTogglePin(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 고정.
   *
   * 콘텐츠를 고정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminContentControllerTogglePin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminContentControllerTogglePin(params: AdminContentControllerTogglePin$Params, context?: HttpContext): Observable<ContentDto> {
    return this.adminContentControllerTogglePin$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContentDto>): ContentDto => r.body)
    );
  }

  /** Path part for operation `userContentControllerSearch()` */
  static readonly UserContentControllerSearchPath = '/api/content/user/search';

  /**
   * 콘텐츠 검색(노출된 것만).
   *
   * 콘텐츠를 검색합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userContentControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  userContentControllerSearch$Response(params: UserContentControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentSearchResponseDto>> {
    return userContentControllerSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 검색(노출된 것만).
   *
   * 콘텐츠를 검색합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userContentControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userContentControllerSearch(params: UserContentControllerSearch$Params, context?: HttpContext): Observable<ContentSearchResponseDto> {
    return this.userContentControllerSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContentSearchResponseDto>): ContentSearchResponseDto => r.body)
    );
  }

  /** Path part for operation `userContentControllerFindById()` */
  static readonly UserContentControllerFindByIdPath = '/api/content/user/{id}';

  /**
   * 콘텐츠 조회.
   *
   * 콘텐츠를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userContentControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  userContentControllerFindById$Response(params: UserContentControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentDto>> {
    return userContentControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 조회.
   *
   * 콘텐츠를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userContentControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userContentControllerFindById(params: UserContentControllerFindById$Params, context?: HttpContext): Observable<ContentDto> {
    return this.userContentControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContentDto>): ContentDto => r.body)
    );
  }

}
